import React, {useEffect, useCallback, useRef, useState} from 'react';
import {Form, Dropdown, Table, Pagination} from 'semantic-ui-react';
import {useReport} from '../../../providers/ReportProvider';
import './SelectCustomerModal.css';

export const SelectCustomerModal = ({
  customer,
  onEquipmentSelect,
  onReportTemplateSelect,
  defaultTemplateId,
  selectedReportTemplateId,
}) => {
  const [equipmentLoading, setEquipmentLoading] = useState(false);
  const {reportTemplates, getReportTemplates, listEquipment} = useReport();
  const pageSize = 10;
  const [pageIndex, setPageIndex] = useState(0);
  const [sortField] = useState('Num');
  const [sortDirection] = useState('asc');

  const [equipmentData, setEquipmentData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState();
  const [templateSelected, setTemplateSelected] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState([]);

  useEffect(() => {
    const reportsOnly = true;
    getReportTemplates(reportsOnly);
  }, [getReportTemplates]);

  const loadEquipment = useCallback(
    (customer, pageIndex, resetData = false) => {
      setEquipmentLoading(true);
      console.log(customer);
      listEquipment(pageSize, pageIndex, sortField, sortDirection, customer.id).then(data => {
        setTotalPages(data.page_count);
        setTotal(data.total);
        const array = (resetData ? [] : equipmentData).concat(data.data);
        console.log(array);
        setEquipmentData(array);
        setEquipmentLoading(false);
      });
    },
    [equipmentData, listEquipment, pageSize, sortField, sortDirection, setEquipmentData]
  );

  const loadEquipmentRef = useRef(loadEquipment);
  loadEquipmentRef.current = loadEquipment;

  useEffect(() => {
    if (customer) {
      setPageIndex(0);
      loadEquipmentRef.current(customer, 0, true);
    }
  }, [customer]);

  const reportTemplateSelect = useCallback(
    reportTemplate => {
      onReportTemplateSelect(reportTemplate);
    },
    [onReportTemplateSelect]
  );

  useEffect(() => {
    if (reportTemplates && !templateSelected) {
      const defaultTemplate = reportTemplates.find(x => x.id === defaultTemplateId);
      if (defaultTemplate) {
        reportTemplateSelect(defaultTemplate);
        setTemplateSelected(true);
      }
    }
  }, [
    reportTemplates,
    reportTemplateSelect,
    defaultTemplateId,
    templateSelected,
    setTemplateSelected,
  ]);

  const equipmentSelect = equipment => {
    onEquipmentSelect(equipment);
    setSelectedEquipment(equipment);
  };

  return (
    <div>
      <Form style={{ maxWidth: '1000px' }}>
        <Form.Group>
          {customer && (
            <Form.Field
              label="Report Template"
              control={Dropdown}
              fluid
              selection
              options={reportTemplates.map(x => ({
                key: x?.id,
                text: x?.name,
                value: x?.id,
              }))}
              value={selectedReportTemplateId}
              style={{height: '38px'}}
              onChange={(e, selected) => {
                const template = reportTemplates.find(x => x.id === selected.value);
                reportTemplateSelect(template);
              }}
              width={16}
              search
            />
          )}
        </Form.Group>
        <Form.Group>
          {selectedEquipment.length > 0 && (
            <div style={{width: '100%', paddingLeft: '0.5em', paddingRight: '0.5em'}}>
              <Dropdown
                placeholder=""
                fluid
                multiple
                selection
                icon={null}
                value={selectedEquipment}
                open={false}
                options={equipmentData?.map(x => ({
                  key: x.id,
                  text: x.name || x.num,
                  value: x.id,
                }))}
                onChange={(e, {value}) => equipmentSelect(value)}
              />
            </div>
          )}
        </Form.Group>
        <Form.Group>
          {customer && selectedReportTemplateId && (
            <div style={{width: '100%', paddingLeft: '0.5em', paddingRight: '0.5em'}}>
              <Table celled selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Num</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {equipmentData.length > 0 && !equipmentLoading
                    ? equipmentData
                        .slice(pageIndex * pageSize, pageIndex * pageSize + pageSize)
                        .map(equipment => (
                          <Table.Row
                            key={equipment.id}
                            active={selectedEquipment.includes(equipment.id)}
                            onClick={() => {
                              if (selectedEquipment.includes(equipment.id)) {
                                equipmentSelect(selectedEquipment.filter(x => x !== equipment.id));
                              } else {
                                equipmentSelect([...selectedEquipment, equipment.id]);
                              }
                            }}
                            style={{cursor: 'pointer'}}
                          >
                            <Table.Cell>{equipment.num}</Table.Cell>
                            <Table.Cell>{equipment.name}</Table.Cell>
                          </Table.Row>
                        ))
                    : [...Array(10)].map((x, i) => (
                        <Table.Row key={i}>
                          <Table.Cell><p>Loading...</p></Table.Cell>
                          <Table.Cell><p>Loading...</p></Table.Cell>
                        </Table.Row>
                      ))}
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="12">
                      <Pagination
                        style={{position: 'initial', float: 'right'}}
                        defaultActivePage={1}
                        totalPages={totalPages}
                        boundaryRange={0}
                        ellipsisItem={null}
                        firstItem={null}
                        lastItem={null}
                        siblingRange={1}
                        onPageChange={(e, {activePage}) => {
                          const page = activePage - 1;
                          setPageIndex(page);
                          const bool = equipmentData.length >= activePage * pageSize;
                          if (!bool && equipmentData.length < total) {
                            loadEquipmentRef.current(customer, page);
                          }
                        }}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </div>
          )}
        </Form.Group>
      </Form>
    </div>
  );
};
